module.exports = __webpack_public_path__ + "media/images/result_sets/circles/6r7n9r3n-f8e5f06f103a9391f89ac51d458f4112.svg";